import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import Select, { ValueType } from 'react-select';
import { Button, Form, Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { Privilege, Server } from '../../clients/aasServerClient.generated';
import { isLoading } from '../../stores/navigation/selectors';
import { clearSingleServer, fetchSingleServer, saveSingleServer } from '../../stores/servers/actionCreators';
import { getSingleServer } from '../../stores/servers/selectors';
import { RootState } from '../../stores/store';
import { workspaceOptions } from '../../stores/workspaces/selectors';
import SideModal from '../common/modals/SideModal';
import { LoadingButton } from '../navigation/LoadingButton';
import LoadingScreen from '../navigation/LoadingScreen';
import ServerProperties from './ServerProperties';

interface Props extends LocalizeContextProps, RouteComponentProps<{ id: string }> {
    isLoading: boolean;
    server: {
        loaded: boolean;
        saved: boolean;
        server?: Partial<Server>;
    };

    fetchSingleServer: (id: string) => void;
    clearSingleServer: () => void;
    saveSingleServer: (
        server: Partial<Server>,
        workspaces?: Array<{ id: string, value: boolean }>,
    ) => void;
}

interface State {
    server?: Partial<Server>;
}

class EditServerPage extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            server: undefined,
        };
        const id = this.props.match.params.id;
        this.props.clearSingleServer();
        this.props.fetchSingleServer(id);
    }

    public componentDidUpdate(prevProps: Props) {
        if (!prevProps.server.loaded && this.props.server.loaded) {
            this.setState({
                server: this.props.server.server,
            });
        }
        if (!prevProps.server.saved && this.props.server.saved) {
            this.closePage();
        }
    }

    public modalRef = React.createRef<HTMLDivElement>();
    public render() {
        const t = this.props.translate;
        return (
            <SideModal
                isOpen={true}
                toggle={this.closePage}
                headerText={t('servers.edit.header.edit') as string}
                footer={this.renderFooter()}
                objectRef={this.modalRef}
            >
                {this.props.server.loaded && this.props.server.server ? (
                    <Form>
                        <h3 className="mb-4 mt-2">{t('servers.edit.section.details')}</h3>
                        <ServerProperties
                            type="edit"
                            server={this.props.server.server}
                            updateServer={this.updateServer}
                        />
                    </Form>
                ) : (
                        <LoadingScreen text={t('loading.loading') as string} />
                    )}
            </SideModal>
        );
    }

    private updateServer = (server: Partial<Server>) => {
        this.setState({
            server,
        });
    }

    private closePage = () => {
        this.props.history.push('/servers');
    }

    private renderFooter = (): React.ReactNode => {
        const t = this.props.translate;
        return (
            <React.Fragment>
                <LoadingButton
                    loading={this.props.isLoading}
                    color="success"
                    onClick={this.saveServer}
                    style={{ width: '200px' }}
                >
                    {t('servers.edit.button.save')}
                </LoadingButton>
            </React.Fragment>
        );
    }

    private saveServer = () => {
        const server = this.state.server;

        this.props.saveSingleServer(server!);
    }
}

const mapStateToProps = (state: RootState) => ({
    isLoading: isLoading(state),
    server: getSingleServer(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    clearSingleServer: () => dispatch(clearSingleServer()),
    fetchSingleServer: (id: string) => dispatch(fetchSingleServer(id)),
    saveSingleServer: (
        server: Partial<Server>,
    ) => dispatch(saveSingleServer(server))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLocalize(EditServerPage)));